import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Axios instance with cookies + Bearer fallback
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Persist bearer token in localStorage as fallback (some browsers block 3rd-party cookies)
const TOKEN_KEY = "ae_access_token";

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export async function downloadBlob(path, filename) {
  const res = await api.get(path, {
    responseType: "blob",
    // Allow us to inspect 4xx blobs (JSON errors) instead of throwing generic
    validateStatus: (s) => s >= 200 && s < 500,
  });
  if (res.status >= 400) {
    // The blob may contain a JSON error body; decode it and throw a real error
    let detail = "";
    try {
      const text = await res.data.text();
      const parsed = JSON.parse(text);
      detail = parsed?.detail || text || `Erreur HTTP ${res.status}`;
    } catch (_) {
      detail = `Erreur HTTP ${res.status}`;
    }
    const err = new Error(detail);
    err.status = res.status;
    err.detail = detail;
    err.response = { status: res.status, data: { detail } };
    throw err;
  }
  const contentType = res.headers?.["content-type"] || "application/octet-stream";
  const cd = res.headers?.["content-disposition"] || "";
  const m = /filename\*?=(?:UTF-8'')?"?([^"';]+)"?/i.exec(cd);
  const inferred = m ? decodeURIComponent(m[1]) : null;
  const url = window.URL.createObjectURL(new Blob([res.data], { type: contentType }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || inferred || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
